import { getAccountId } from "../../components/AlmeApp/initialize/loginState";
import { MessageHandlerBase } from "./MessageHandlerBase";
const ManageAccountsAppEvent = "ConsumerCenterManageAccounts";
export default class ManageAccountsHandler extends MessageHandlerBase {
    handle(message) {
        if (!this.almeState.sessionExpired && this.almeState.history.length) {
            this.sendAppEvent(message, ManageAccountsAppEvent);
        }
    }
    createApiParams(message) {
        const apiParams = super.createApiParams(message);
        if (apiParams.UserObj === undefined || apiParams.UserObj === null) {
            const userMetadata = this.appConfig.main.userMetadata;
            const userData = {
                accountId: getAccountId(this.almeState, this.appConfig.main.clientSessionId, userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.accountId),
                emailId: userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.emailId,
            };
            apiParams.UserObj = userData;
        }
        return apiParams;
    }
}
